(function () {
  'use strict';
  if (window.ONAIR_UNDER4K_EVENTS_ATTACHED) return;
  window.ONAIR_UNDER4K_EVENTS_ATTACHED = true;

  function allowed() {
    var launch = window.ONAIR_LAUNCH;
    try {
      return launch?.production === true && launch.campaignActive === true &&
        window.Shopify?.designMode !== true &&
        window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (error) {
      return false;
    }
  }

  function publish(details) {
    if (!allowed()) return;
    var data = Object.assign({
      campaign: 'onair_under4k',
      kit_tier: 'essential',
      kit_release: 'complete_kits_v4',
      traffic_type: 'production',
      schema_version: 1
    }, details);
    var analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish === 'function') {
      try {
        var result = analytics.publish('onair:under4k_click', data);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      } catch (error) {}
      return;
    }
    if (window.ONAIR_LAUNCH?.dataLayerEnabled === true && Array.isArray(window.dataLayer)) {
      try {
        window.dataLayer.push(Object.assign({event: 'onair_under4k_click'}, data));
      } catch (error) {}
    }
  }

  document.addEventListener('click', function (event) {
    if (!allowed()) return;
    var target = event.target?.closest?.('a[data-onair-campaign-link], a[href*="entry="], a[href*="utm_campaign=under4k"]');
    if (!target) return;
    var destination;
    try { destination = new URL(target.href, window.location.href); } catch (error) { return; }
    if (destination.origin !== window.location.origin) return;
    var kitPath = destination.pathname.endsWith('/pages/onair-complete-air-ride-kits');
    var fallbackPath = destination.pathname.endsWith('/pages/about-us') && destination.searchParams.get('view') === 'onair-complete-kits';
    if ((!kitPath && !fallbackPath) || destination.searchParams.get('package') !== 'essential') return;
    var placement = target.dataset.onairPlacement || destination.searchParams.get('entry') || destination.searchParams.get('utm_medium');
    if (!['announcement', 'hero', 'product_alternative', 'shopping_paths', 'included', 'management', 'campaign'].includes(placement)) {
      placement = 'campaign_link';
    }
    publish({placement: placement, destination: destination.pathname});
  }, {passive: true});
})();
